/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duration_3_DaysInputs */

const en_duration_3_days = /** @type {(inputs: Duration_3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Days`)
};

const es_duration_3_days = /** @type {(inputs: Duration_3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 dias`)
};

/**
* | output |
* | --- |
* | "3 Days" |
*
* @param {Duration_3_DaysInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const duration_3_days = /** @type {((inputs?: Duration_3_DaysInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duration_3_DaysInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_duration_3_days(inputs)
	return es_duration_3_days(inputs)
});